<template>
    <div class="cabinet-detail-table">
        <div v-if="product.ItemInsert" class="cabinet-detail-table__row" v-html="product.ItemInsert" />

        <div v-if="!product.inserts.length && !product.ItemInsert" class="cabinet-detail-table__row">
            Вставки отсутствуют
        </div>

        <section v-for="(insert, i) of product.inserts" :key="insert.ItemInsertID">
            <div class="cabinet-detail-table__title" :class="i === 0 ? 'cabinet-detail-table__row ' : 'cabinet-detail-table__row--divided '">
                {{ nameInsertMaterial(insert.MaterialID) }}
            </div>

            <div v-if="insert.Quantity" class="cabinet-detail-table__row flex flex-justify-sb flex-align-start">
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">Количество камней</span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ insert.Quantity }}
                </div>
            </div>

            <div v-if="insert.ColorID" class="cabinet-detail-table__row flex flex-justify-sb flex-align-start">
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">Цвет вставки</span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ nameInsertColor(insert.ColorID) }}
                </div>
            </div>

            <div v-if="insert.Clarity" class="cabinet-detail-table__row flex flex-justify-sb flex-align-start">
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">Чистота вставки</span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ insert.Clarity }}
                </div>
            </div>

            <div v-if="insert.FacetID || insert.FaceNumber" class="cabinet-detail-table__row flex flex-justify-sb flex-align-start">
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">Огранка</span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ nameInsertFacet(insert.FacetID) }}
                    <span v-if="insert.FaceNumber">, граней: {{ insert.FaceNumber }}</span>
                </div>
            </div>

            <div v-if="insert.Size" class="cabinet-detail-table__row flex flex-justify-sb flex-align-start">
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">Общая каратность</span>
                </div>
                <div class="cabinet-detail-table__cell">{{ insert.Size }} crt</div>
            </div>
        </section>
    </div>
    <!-- /cabinet-detail-table -->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ProductInserts',
    props: {
        product: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        ...mapGetters('supplierProducts', ['getFormattedProduct']),
        ...mapGetters('insert', ['nameInsertMaterial', 'nameInsertColor', 'nameInsertFacet'])
    },
    watch: {
        getFormattedProduct: {
            handler: function(val) {
                if (!this.product.id && Object.keys(val).length) {
                    this.setProductFields()
                }
            },
            deep: true
        }
    },
    mounted() {
        if (Object.keys(this.getFormattedProduct).length) {
            this.setProductFields()
        }
    },
    methods: {
        setProductFields() {
            this.product = {
                ...this.getFormattedProduct
            }
        }
    }
}
</script>
